import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ScrollText } from 'lucide-react';

const TermsOfUsePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-blue-100 px-4 py-8">
      <div className="w-full max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-indigo-600 hover:text-indigo-700 mb-8 font-semibold transition-colors">
          <ArrowLeft className="w-5 h-5" />
          Back to Home
        </Link>

        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <div className="flex items-center gap-3 mb-8">
            <ScrollText className="w-8 h-8 text-indigo-600" />
            <h1 className="text-3xl md:text-4xl font-black text-gray-900">Terms of Use</h1>
          </div>

          <div className="space-y-6 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">1. Trial Version Notice</h2>
              <p>Famitry is currently provided as a "Trial Version" (Beta). The service is provided on an "as-is" and "as-available" basis for evaluation purposes. No guarantees are made regarding uptime, data retention, or feature completeness.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">2. User Responsibility</h2>
              <p>You agree to provide accurate and lawful information when documenting your family heritage. You are solely responsible for the content you submit and its compliance with applicable laws.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">3. Data Privacy & Security</h2>
              <p>We take reasonable measures to protect your data, but cannot guarantee absolute security. Your data may be stored on third-party servers (e.g., Google Firebase). By using Famitry, you consent to such storage and processing. Please review our Privacy Policy for details.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">4. Data Retention & Deletion</h2>
              <p>You may request deletion of your data at any time. We reserve the right to retain or remove data as required by law or for operational purposes.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">5. Third-Party Services</h2>
              <p>Famitry integrates with third-party services (such as Google, Firebase, and others). We are not responsible for the practices or content of these services. Your use of such services is subject to their respective terms and privacy policies.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">6. Limitation of Liability</h2>
              <p>Famitry and its developers are not liable for any direct, indirect, incidental, or consequential damages arising from your use of the app. Use at your own risk.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">7. Indemnification</h2>
              <p>You agree to indemnify and hold harmless Famitry, its developers, and affiliates from any claims, damages, or expenses arising from your use of the app or violation of these terms.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">8. Dispute Resolution</h2>
              <p>Any disputes arising from your use of Famitry will be governed by the laws of your jurisdiction. We encourage users to resolve disputes amicably.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">9. Changes to Terms</h2>
              <p>We may update these Terms of Use at any time. Continued use of Famitry constitutes acceptance of the latest terms.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">10. Contact</h2>
              <p>For questions or concerns, contact us at <a href="mailto:admin@famitry.in" className="text-indigo-600 hover:underline">admin@famitry.in</a>.</p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <Link to="/" className="inline-block px-8 py-3 bg-indigo-600 text-white rounded-xl font-bold hover:bg-indigo-700 transition-colors">
              Return Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUsePage;
